import { UserType, Entity } from '../entities';
import * as Enumerable from 'linq';

export enum SecurityRoleType {
    EmployeeAdministrator = 'Administrator',
    EmployeeTechnician = 'Technician',
    EmployeeOperations = 'Operations',
    EmployeeScheduler = 'Scheduler',
    EmployeeFinance = 'Finance',
    EmployeeCompliance = 'Compliance',
    SubcontractorAdministrator = 'Subcontractor Administrator',
    SubcontractorUser = 'Subcontractor User',
    SystemAdministrator = 'System Administrator',
    ClientUser = 'Client User',
    None = 'None',
}


export interface SecurityRole {
    _id: string;
    name: string;
    hidden?: boolean;
    type: UserType;
    system: boolean;
    description: string;
    rights: number[];
    inUse?: boolean;
}

export interface SecurityRoleTiny {
    _id?: string;
    name: string;
    type: UserType;
    rights: number[];
}

export interface RoleEntity extends Entity {
    type: UserType;
}

export class LoginContactSecurityRoleTiny implements SecurityRoleTiny {

    // public static id = '00000000-0000-0000-0000-000000000001';

    // public readonly _id = LoginContactSecurityRoleTiny.id;
    public readonly rights: number[];
    public type = UserType.LoginContact;
    // public readonly isClient: boolean;
    // public readonly isSubContractor: boolean;
    public readonly name = 'Login Contact Combined Role';


    constructor(roles: SecurityRoleTiny[]) {
        this.rights = Enumerable.from(roles).selectMany(x => x.rights).toArray();
        // this.isClient = Enumerable.from(roles).any(x => x.type === UserType.Client);
        // this.isSubContractor = Enumerable.from(roles).any(x => x.type === UserType.Subcontractor);
    }
}
